import { render } from "./ArticleCard.vue?vue&type=template&id=6824230e&scoped=true"
import script from "./ArticleCard.vue?vue&type=script&lang=js"
export * from "./ArticleCard.vue?vue&type=script&lang=js"

import "./ArticleCard.vue?vue&type=style&index=0&id=6824230e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6824230e"]])

export default __exports__